import { lazy } from "react"
import { RouteProps } from "../features.types"

const DeliveryController = lazy(() => import("./delivery-controller"))
const DeliveryHome = lazy(() => import("./delivery"))
// define route constant
export const DELIVERY_ROUTE = "delivery"

//define routes
export const Delivery: RouteProps[] = [
  {
    path: `${DELIVERY_ROUTE}/:referralpage`,
    Component: DeliveryController,
    children: [
      {
        index: true,
        Component: DeliveryHome,
      },
    ],
  },
]
